import useWindowDimensions from '@utils/hooks/useWindowDimension';
import iub from '@utils/ImageUrlBuilder';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
interface Size {
  width: number | undefined;
  height: number | undefined;
}
type Props = {
  asset;
  alt: string;
  caption: string;
};

const SingleImg: FunctionComponent<Props> = (image) => {
  const size: Size = useWindowDimensions();

  return (
    <div className={styles.root}>
      <div
        style={{
          backgroundImage: `url(${iub(image.asset)
            .width(size.width <= 768 ? 600 : 1000)
            .url()})`,
        }}
        title={image.alt}
        className={styles.singleImg}
      />
      <p className={styles.caption}>{image.caption}</p>
    </div>
  );
};

export default SingleImg;
